import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import type { TimesheetDeadlineSettings } from '@/types/timesheetSettings';

interface MissingTimesheetReminderSettingsProps {
  settings: TimesheetDeadlineSettings;
  onChange: (settings: TimesheetDeadlineSettings, isValid: boolean) => void;
}

export const MissingTimesheetReminderSettings: React.FC<MissingTimesheetReminderSettingsProps> = ({
  settings,
  onChange,
}) => {
  const handleSendFeedRemindersChange = (checked: boolean) => {
    const newSettings = {
      ...settings,
      sendFeedReminders: checked,
    };
    onChange(newSettings, true);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Missing Timesheet Reminders</CardTitle>

      </CardHeader>
      <CardContent className="space-y-4">

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="sendFeedReminders">Missing Timesheet Report Reminders</Label>
            <p className="text-sm text-muted-foreground">
              Allow sending reminders for missing timesheets from the Missing Timesheet Report
            </p>
          </div>
          <Switch
            id="sendFeedReminders"
            checked={settings.sendFeedReminders}
            onCheckedChange={handleSendFeedRemindersChange}
          />
        </div>

      </CardContent>
    </Card>
  );
};
